import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, getDocs, updateDoc, deleteDoc, doc, query, orderBy, setDoc, getDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC8hsqkHV4VTVGB2mkq7avtlj2oasaUiTY",
  authDomain: "seowebsite-1850e.firebaseapp.com",
  projectId: "seowebsite-1850e",
  storageBucket: "seowebsite-1850e.firebasestorage.app",
  messagingSenderId: "33711523646",
  appId: "1:33711523646:web:38a5609cf7c75011748e6f",
  measurementId: "G-TXZLB4BV87"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

const BLOG_COLLECTION = "blog_posts";
const CONFIG_COLLECTION = "site_config";

export const settingsService = {
  async getSettings() {
    const docRef = doc(db, CONFIG_COLLECTION, "global");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return docSnap.data();
    }
    return { bookingUrl: "#booking" };
  },
  async updateSettings(settings) {
    const docRef = doc(db, CONFIG_COLLECTION, "global");
    return await setDoc(docRef, settings, { merge: true });
  }
};

export const blogService = {
  getPublishTimestamp(dateStr) {
    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day, 7, 0, 0));
    return date.toISOString();
  },

  async getPosts(isAdmin = false) {
    const q = query(collection(db, BLOG_COLLECTION), orderBy("publishDate", "desc"));
    const querySnapshot = await getDocs(q);
    const allPosts = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    
    if (isAdmin) return allPosts;

    const now = new Date().toISOString();
    return allPosts.filter(post => post.publishDate <= now);
  },

  async addPost(post) {
    const publishDate = this.getPublishTimestamp(post.scheduledDate);
    return await addDoc(collection(db, BLOG_COLLECTION), {
      ...post,
      publishDate,
      createdAt: new Date().toISOString(),
      displayDate: new Date(post.scheduledDate + 'T12:00:00').toLocaleDateString('en-US', { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric' 
      })
    });
  },

  async updatePost(id, post) {
    const publishDate = this.getPublishTimestamp(post.scheduledDate);
    const postRef = doc(db, BLOG_COLLECTION, id);
    return await updateDoc(postRef, {
      ...post,
      publishDate,
      displayDate: new Date(post.scheduledDate + 'T12:00:00').toLocaleDateString('en-US', { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric' 
      })
    });
  },

  async deletePost(id) {
    const postRef = doc(db, BLOG_COLLECTION, id);
    return await deleteDoc(postRef);
  }
};